interface TimestampObject {
  timestamp: number;
  utcOffset: number;
}

export const generateTimestamps = (
  startTime: number,
  endTime: number,
  utcOffset: number,
): TimestampObject[][] => {
  const timestamps: TimestampObject[][] = [];

  // Get the start and end dates
  const startDate = new Date(startTime * 1000);
  const endDate = new Date(endTime * 1000);

  // Iterate through each hour until the end date
  let currentDay: TimestampObject[] = [];
  const newDayHourIndex = startDate.getUTCHours();

  while (startDate < endDate) {
    currentDay.push({
      timestamp: startDate.getTime() / 1000,
      utcOffset,
    });

    // Move to the next hour
    startDate.setUTCHours(startDate.getUTCHours() + 1);

    // If the current hour is the beginning of a new day, start a new inner array
    if (startDate.getUTCHours() === newDayHourIndex) {
      timestamps.push(currentDay);
      currentDay = [];
    }
  }

  // Add the last day's timestamps
  if (currentDay.length > 0) {
    timestamps.push(currentDay);
  }

  return timestamps;
};
